var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { round } from '../../../../utils/helper/lodash_replacements';
export class ImageDimensions {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get image() {
        return this.parent;
    }
    get width() {
        return round(this.widthFromTraits || this.widthFromNatural || 50, 2);
    }
    set width(value) {
        this.image.essence.local.valueOf.imageWidth = value;
    }
    get widthFromTraits() {
        return this.image.essence.valueOf.imageWidth;
    }
    get widthFromNatural() {
        return this.image.img.naturalWidth_pixel; //  / this.imageActor.context.widthRatio
    }
    get height() {
        return round(this.heightFromTraits || this.heightFromNatural || 50, 2);
    }
    set height(value) {
        this.image.essence.local.valueOf.imageHeight = value;
    }
    get heightFromTraits() {
        return this.image.essence.valueOf.imageHeight;
    }
    get heightFromNatural() {
        return this.image.img.naturalHeight_pixel; //  / this.imageActor.context.heightRatio
    }
}
__decorate([
    computed
], ImageDimensions.prototype, "width", null);
__decorate([
    computed
], ImageDimensions.prototype, "widthFromTraits", null);
__decorate([
    computed
], ImageDimensions.prototype, "widthFromNatural", null);
__decorate([
    computed
], ImageDimensions.prototype, "height", null);
__decorate([
    computed
], ImageDimensions.prototype, "heightFromTraits", null);
__decorate([
    computed
], ImageDimensions.prototype, "heightFromNatural", null);
